// extracted by mini-css-extract-plugin
export default {"component":"b1K18o","text":"c1K18o"};